<template>
  <section>
    <Requirements v-if="hasRequirements" />
    <NoRequirements
      v-else
      :setup-mode="setupMode"
    />
  </section>
</template>

<script type="text/babel">
import Requirements from './Requirements'
import NoRequirements from './NoRequirements'
import { mapState } from 'vuex'

export default {
  name: 'RequirementsContainer',
  components: {
    Requirements,
    NoRequirements,
  },
  props: {
    setupMode: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapState({
      stripeAccount: state => state.payments.stripeAccount,
    }),
    hasRequirements() {
      return !_.isEmpty(this.stripeAccount)
        ? (
          !!this.stripeAccount.requirements.currently_due.length ||
          !!this.stripeAccount.future_requirements.currently_due.length
        )
        : true
    },
  },
}
</script>